import React, { useState, useEffect, useRef } from "react";
import axios from "axios";

const API_URL = (process.env.REACT_APP_API_URL || "").replace(/\/+$/, "");

const HighscoreModal = ({
  isOpen,
  onClose,
  score,
  level,
  onSuccess
}) => {

  const [name, setName] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);
  const submittingRef = useRef(false);

  useEffect(() => {
    if (isOpen) {
      setSuccess(false);
      setName("");
      setError("");
      setLoading(false);
      submittingRef.current = false;
    }
  }, [isOpen]);

  if (!isOpen) return null;



  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submittingRef.current) return;

    const trimmedName = name.trim();

    if (trimmedName.length < 2) {
      setError("Veuillez entrer un nom d'au moins 2 caractères");
      return;
    }

    if (trimmedName.length > 25) {
      setError("Le nom ne doit pas dépasser 25 caractères");
      return;
    }

    submittingRef.current = true;
    setLoading(true);
    setError("");

    const payload = {
      jeu: "velo",
      nom: trimmedName,
      score,
      level
    };
    console.log("highscore submit", { nom: trimmedName, score, level, apiUrl: API_URL });

    let newScore;
    try {
      const res = await axios.post(
        `${API_URL}/api/highscore`,
        payload
      );

      newScore = res.data;

    } catch (err) {
      console.error("highscore error", {
        status: err.response?.status,
        data: err.response?.data,
        message: err.message
      });
      setError(
        err.response?.data?.message ||
        "Erreur lors de l'enregistrement du score"
      );
      submittingRef.current = false;
      setLoading(false);
      return;
    }

    // Une erreur du callback UI ne doit jamais présenter un POST réussi comme échoué.
    setSuccess(true);
    setName("");
    setLoading(false);
    onSuccess?.(newScore);
  };

  const handleClose = () => {
    if (loading) return;
    setName("");
    setError("");
    setSuccess(false);
    onClose();
  };

  return (
    <div  className="fixed inset-0 bg-black/60 flex items-center justify-center z-50"
          data-game-ui
          role="dialog"
          aria-modal="true"
          aria-labelledby="highscore-title"
          onTouchStart={(e) => e.stopPropagation()}
          onClick={(e) => e.stopPropagation()}>

      <div className="bg-white rounded-xl p-6 w-96 relative shadow-xl">

        {/* ❌ bouton fermer */}
        <button
          type="button"
          disabled={loading}
          onClick={handleClose}
          className="absolute top-2 right-3 text-gray-500 hover:text-black text-xl"
        >
          ×
        </button>

        {/* 🎮 titre */}
        <h2 id="highscore-title" className="text-2xl font-bold mb-2 text-center">
          Nouveau record !
        </h2>

        {/* 📊 infos score */}
        <div className="text-center mb-4">
          <p className="text-lg font-semibold">Score : {score}</p>
          <p className="text-sm text-gray-600">Niveau : {level}</p>
        </div>

        {/* ✅ succès */}
        {success ? (
          <div className="text-center">
            <p className="text-green-600 font-semibold mb-4">
              Score enregistré !
            </p>

            <button
              type="button"
              onClick={handleClose}
              className="bg-yellow-400 hover:bg-yellow-500 text-white px-4 py-2 rounded"
            >
              Continuer
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit} aria-label="Enregistrement du score" className="flex flex-col gap-3" >
            <input
              type="text"
              name="nom"
              disabled={loading}
              placeholder="Ton nom"
              value={name}
              onChange={(e) => {
                let value = e.target.value;

                // 🔥 limite + gestion propre
                if (value.length > 25) {
                  value = value.slice(0, 25);
                  setError("Maximum 25 caractères");
                } else {
                  setError("");
                }

                setName(value);
              }}
              maxLength={25}
              className="border border-gray-300 rounded px-3 py-2 text-center"
            />

            {/* 🔥 ALERTE ERREUR */}
            {error && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-3 py-2 rounded text-center">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={loading}
              className="bg-yellow-400 hover:bg-yellow-500 text-white font-semibold py-2 rounded transition disabled:opacity-50"
            >
              {loading ? "Envoi..." : "Enregistrer"}
            </button>

          </form>
        )}
      </div>
    </div>
  );
};

export default HighscoreModal;
